/*
 * @Author: mazhenjie mazhenjie@soidentify.com
 * @Date: 2025-04-01 19:25:47
 * @LastEditors: mazhenjie mazhenjie@soidentify.com
 * @LastEditTime: 2025-04-14 16:05:45
 * @FilePath: /dingjian-web/src/main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import router from './router/index'
import 'animate.css';
const app = createApp(App)
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

// // 引入elementui
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.use(ElementPlus)

app.use(pinia);

app.use(router)

app.mount('#app')